import React from 'react'
import { 
    Chip,
    Stack,
    Typography
 } from '@mui/material'
import { lightenColor } from '../../utils/colorCreator'

export default function JobBenefits({benefits, primary_color, secondary_color}) {

    const primary = lightenColor(primary_color, 45); // Lighten by 30%

    if (benefits && benefits.length > 0) {
        return (
            <Stack>
                <Stack direction='row' flexWrap="wrap" gap={1}>
                    {
                        benefits.map((benefit, index) => (
                            <Chip 
                                key={index}
                                label={benefit}
                                sx={{
                                    borderRadius: '10px',
                                    backgroundColor: "#505080",   // Custom background color
                                    color: '#ffffff',            // Set text color to white (or another color for better contrast)
                                    fontSize: "14px",
                                    fontWeight: "600"
                                }} 
                                variant="filled"
                            />
                        ))
                    }
                </Stack>
            </Stack>
        )
    }
}
